import Footer from "@/components/home/Footer";
import Header from "@/components/home/Header";
import Navbar from "@/components/home/Navbar";
import MyRegistrationComponent from "@/components/myRegistration/MyRegistrationComponent";
import MyRegistrationHero from "@/components/myRegistration/MyRegistrationHero";

const MyRegistration = () => {
  return (
    <section>
      <div className="w-full bg-white fixed z-50 ">
        <Header />
        <Navbar />
      </div>
      <MyRegistrationHero />
      <MyRegistrationComponent />
      <Footer />
    </section>
  );
};

export default MyRegistration;
